import { useRef, useContext, useState, useEffect } from 'react';

import styles from './ImageFileComponent.module.css'

import { GlobalContext } from "../contexts/globalContext"


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons'

import CustomMultitouchComponent from "./CustomMultitouchComponent"
import ParticipantsToShareComponent from "../components/conferenceScreen/ParticipantsToShareComponent";

import ShareIcon from "../graphics/conference/share.svg"
import HandoverIcon from "../graphics/conference/handover.svg"
import HandoverOffIcon from "../graphics/conference/handover-off.svg";
import resizeButton from '../graphics/conferenceScreen/note/expand.svg';

import { GetMaxZIndex, isTouchDevice } from '../utils/UtilitaryFunctions';

import { fromString } from 'transformation-matrix';


const ImageFileComponent = ({ file, shared }) => {
    const {
        setSharedFiles, setOpenedFiles, appWidth, appHeight, currentParticipant, currentTopic, sharedFiles, socketRef, currentConference
    } = useContext(GlobalContext);

    const ref = useRef(null);
    const imgRef = useRef(null);
    const mtRef = useRef(null);
    var enableComponentTimeout = useRef();
    const mustBeDeletedRef = useRef();
    const updateRequiredRef = useRef();
    const sharedFilesRef = useRef();
    const scalingButtonsRef = useRef(1);
    const canvasRef = useRef()
    const isOpenCanvasRef = useRef()
    const linesRef = useRef([])
    const fileRef = useRef(null);
    const imageAspectRatioRef = useRef(1);
    const isResizeNecessary = useRef(true);
    const resizeButtonRef = useRef();
    const scalingResizeRef = useRef(1);

    const [buttonsHeight, setButtonsHeight] = useState(50);
    const [buttonsWidth, setButtonsWidth] = useState(42);
    const [isVisible, setIsVisible] = useState(false);
    // const [buttonsTop, setButtonsTop] = useState(-120);
    const [opacity, setOpacity] = useState(0);
    const [enableComponent, setEnableComponent] = useState("auto");
    const [showParticipantsToShare, setShowParticipantsToShare] = useState(false);
    const [lines, setLines] = useState([]);
    const [openCanvas, setOpenCanvas] = useState(false);
    const [isDrawing, setIsDrawing] = useState(false);
    const [currentLine, setCurrentLine] = useState([]);
    const [currentColor, setCurrentColor] = useState("red");
    const [currentStrokeWidth, setCurrentStrokeWidth] = useState(3);
    const [useSmallDrawMenu, setUseSmallDrawMenu] = useState(false)
    const [width, setWidth] = useState(60)
    const [height, setHeight] = useState(75)
    const [baseSize, setBaseSize] = useState({ w: 1000, h: 1000 });

    const oxDivider = window.innerWidth / appWidth;
    const oyDivider = window.innerHeight / appHeight;

    const startingHeight = 1000;

    const options = {
        appWidth,
        appHeight,
        maxScale: appHeight / startingHeight,
        minScale: 0.5
    }

    const calculateWidth = () => {
        if (imgRef.current) {
            const containerHeight = startingHeight;
            const image = imgRef.current;

            const imageAspectRatio = image.height / image.width;

            const containerWidth = containerHeight / imageAspectRatio

            return [containerWidth, imageAspectRatio];
        }

        return [0, 1];
    };

    const containerStyle = {
        width: width,
        height: height,
        backdropFilter: `${isVisible ? 'blur(10px)' : ''}`,
        backgroundColor: `${isVisible ? 'rgba(0, 0, 0, 0.3)' : 'transparent'}`,
    };

    const getButtonStyle = (right, top = 10, width = "auto") => ({
        transition: "opacity 0.3s",
        position: "absolute",
        flexDirection: "'row",
        transform: `scale(${1 / scalingButtonsRef.current})`,
        transformOrigin: "top right",
        right: right / scalingButtonsRef.current,
        top: top / scalingButtonsRef.current,
        height: buttonsHeight,
        fontSize: buttonsHeight / 2,
        width,
        opacity
    });

    useEffect(() => {
        setLines([]);
        mustBeDeletedRef.current = false;
        updateRequiredRef.current = true;

        if (file.isNew) {
            mtRef.current.style.zIndex = GetMaxZIndex() + 1;
            file.isNew = false;
        }

        setButtonsHeight((startingHeight - 60) / 16)
        setButtonsWidth((startingHeight - 60) / 16 / 1.19)

        window.addEventListener('pointermove', resizePointerMove);
        window.addEventListener('pointerup', windowPointerUp)

        return () => {
            window.removeEventListener('pointermove', resizePointerMove)
            window.removeEventListener('pointerup', windowPointerUp)
        }
    }, [])

    const onDragStart = () => {
        if (shared) {
            ShareDocument(true, false);
        }
    }


    const onMinScaleReached = () => {
        mustBeDeletedRef.current = true;

        setOpenedFiles(files => files.filter(a => a.uid !== file.uid));

        if (shared) {
            var filtrat = sharedFilesRef.current.filter(a => a.uid !== file.uid);
            setSharedFiles(filtrat);
            currentConference.shared_data = JSON.stringify(filtrat);
            socketRef.current.emit("UPDATE_SHARE", currentConference._id, filtrat, file.uid);
        }
    }

    const onPinch = (currentScale) => {
        setIsDrawing(false)

        scalingButtonsRef.current = currentScale
        scalingResizeRef.current = currentScale

        if (currentScale * currentScaleRef.current < 1) {
            setUseSmallDrawMenu(true)
        } else {
            setUseSmallDrawMenu(false)
        }

        if (shared) {
            if (!mustBeDeletedRef.current) {
                ShareDocument(false, false);
            }
        }
    }

    const onGestureEnded = () => {
        if (shared) {
            if (!mustBeDeletedRef.current) {
                ShareDocument(false, true);
            }
        } else {
            SaveOpenedFilesState();
        }
    }

    const SaveOpenedFilesState = () => {
        updateRequiredRef.current = false;
        file.transform = mtRef.current?.style.transform;

        file.resizeWidth = widthRef.current
        file.resizeHeight = heightRef.current

        setOpenedFiles(objs =>
            objs.map(item =>
                item.uid === file.uid ? file : item
            )
        );
    }

    const ShareDocument = (bringToFront, mustSaveInDB = true) => {
        updateRequiredRef.current = false;
        sharedFilesRef.current = sharedFilesRef.current.filter(a => a.uid !== fileRef.current.uid);
        fileRef.current.bringToFront = bringToFront;

        fileRef.current.transform = mtRef.current?.style.transform;

        if (!fileRef.current.sharedBy) {
            fileRef.current.sharedBy = currentParticipant?._id;
            fileRef.current.sharedByName = currentParticipant?.name;
        }

        if (!fileRef.current.moderatedBy) {
            fileRef.current.moderatedBy = currentParticipant?._id;
            fileRef.current.moderatedByName = currentParticipant?.name;
        }

        fileRef.current.changedBy = currentParticipant?._id;
        fileRef.current.changedName = currentParticipant?.name;
        fileRef.current.lines = linesRef.current;

        fileRef.current.resizeWidth = widthRef.current
        fileRef.current.resizeHeight = heightRef.current

        sharedFilesRef.current = [...sharedFilesRef.current, fileRef.current];

        setOpenedFiles(devices => devices.filter(a => a.uid !== fileRef.current.uid));

        currentConference.shared_data = JSON.stringify(sharedFilesRef.current);
        socketRef.current.emit("UPDATE_SHARE", currentConference._id, sharedFilesRef.current, fileRef.current.uid, mustSaveInDB);
    }

    useEffect(() => {
        mtRef.current.style.msTouchAction = enableComponent;
        mtRef.current.style.pointerEvents = enableComponent;
        mtRef.current.style.touchAction = enableComponent;

        ref.current.style.msTouchAction = enableComponent;
        ref.current.style.pointerEvents = enableComponent;
        ref.current.style.touchAction = enableComponent;
    }, [enableComponent])

    useEffect(() => {
        fileRef.current = file;
        mtRef.current.style.transition = "";
        clearTimeout(enableComponentTimeout.current);
        if (shared && !file.bringToFront) {
            if (file.changedBy === currentParticipant?._id) {
                if (currentParticipant?._id === file.moderatedBy || currentParticipant?._id === file.sharedBy) {
                    setEnableComponent("auto");
                } else {
                    setEnableComponent("none");
                }

            } else {
                setEnableComponent("none");

                enableComponentTimeout.current = setTimeout(() => {
                    if (currentParticipant?._id === file.moderatedBy || currentParticipant?._id === file.sharedBy) {
                        setEnableComponent("auto");
                    } else {
                        setEnableComponent("none");
                    }
                }, 100)
            }
        }

        if (file.changedBy !== currentParticipant?._id || updateRequiredRef.current) {
            if (file.bringToFront) {
                mtRef.current.style.zIndex = GetMaxZIndex() + 1;
            }

            if (file.lines) {

                const areDifferent = JSON.stringify(file.lines) !== JSON.stringify(linesRef.current);

                if (areDifferent) {
                    setLines(file.lines);
                    linesRef.current = file.lines;
                }
            }

            if (file.transform) {
                mtRef.current.style.transform = file.transform;
                let mat = fromString(file.transform);
                let currentScale = Math.sqrt(mat.a * mat.a + mat.b * mat.b)

                scalingButtonsRef.current = currentScale
                scalingResizeRef.current = currentScale

                if (currentScale * currentScaleRef.current < 1) {
                    setUseSmallDrawMenu(true)
                } else {
                    setUseSmallDrawMenu(false)
                }
            }

            if (file.changedBy !== currentParticipant?._id) {
                isResizeNecessary.current = true;
            }

            if (file.resizeWidth && isResizeNecessary.current) {
                widthRef.current = file.resizeWidth
                setWidth(file.resizeWidth)
            }

            if (file.resizeHeight && isResizeNecessary.current) {
                heightRef.current = file.resizeHeight
                setHeight(file.resizeHeight)
            }

        } else {
            updateRequiredRef.current = true;
        }
    }, [file])

    useEffect(() => {
        sharedFilesRef.current = sharedFiles;
    }, [sharedFiles])

    const ChangeModerator = (participant) => {
        updateRequiredRef.current = false;
        sharedFilesRef.current = sharedFilesRef.current.filter(a => a.uid !== file.uid);


        file.moderatedBy = participant._id;
        file.moderatedByName = participant.name;

        file.bringToFront = false;


        sharedFilesRef.current = [...sharedFilesRef.current, file];

        setOpenedFiles(devices => devices.filter(a => a.uid !== file.uid));

        currentConference.shared_data = JSON.stringify(sharedFilesRef.current);
        socketRef.current.emit("UPDATE_SHARE", currentConference._id, sharedFilesRef.current, file.uid);
    }

    const touchClicked_handler = () => {
        if (openCanvas) return;

        if (opacity === 0) {
            setOpacity(1)
        } else {
            setOpacity(0)
        }
    }

    const GetStyle = () => {
        if (enableComponent === "none") {
            return styles.touch_component_shared;
        }
        return !shared ? styles.touch_component :
            (currentParticipant?._id === file.moderatedBy || currentParticipant?._id === file.sharedBy) ? styles.touch_component_moderator : styles.touch_component_shared;
    }

    useEffect(() => {
        isOpenCanvasRef.current = openCanvas
    }, [openCanvas])

    function toViewBoxPoint(clientX, clientY) {
        const rect = canvasRef.current.getBoundingClientRect();

        // pointer in element space (CSS px)
        const px = clientX - rect.left;
        const py = clientY - rect.top;

        // convert CSS px -> viewBox units
        const x = (px / rect.width) * baseSize.w;
        const y = (py / rect.height) * baseSize.h;

        return [x, y];
    }

    const Down = (clientX, clientY) => {
        if (!openCanvas) return;
        setIsDrawing(true);
        const p = toViewBoxPoint(clientX, clientY);
        setCurrentLine([p]); // start fresh
    };

    const Move = (clientX, clientY) => {
        if (!openCanvas || !isDrawing) return;
        const p = toViewBoxPoint(clientX, clientY);
        setCurrentLine(prev => [...prev, p]);
    };

    const Up = () => {
        if (!openCanvas) return;
        setIsDrawing(false);

        // read currentLine from state (closure is fine here because Up runs on event)
        if (currentLine.length === 0) {
            setCurrentLine([]);
            return;
        }

        const nextLines = [
            ...linesRef.current,
            { points: currentLine, color: currentColor, strokeWidth: currentStrokeWidth }
        ];

        linesRef.current = nextLines;
        setLines(nextLines);

        setCurrentLine([]); // pure

        if (shared && !mustBeDeletedRef.current) {
            ShareDocument(false, true); // side effect happens AFTER state setters
        }

        // setCurrentLine(prev => {
        //     if (prev.length > 0) {
        //         linesRef.current = [
        //             ...linesRef.current,
        //             { points: prev, color: currentColor, strokeWidth: currentStrokeWidth }
        //         ];
        //         setLines(linesRef.current);
        //         ShareDocument(false, true);
        //     }
        //     return [];
        // });
    };

    const onMouseDown = (e) => {
        e.stopPropagation()
        Down(e.clientX, e.clientY)
    };
    const onMouseMove = (e) => {
        e.stopPropagation()
        Move(e.clientX, e.clientY);
    }

    const onTouchStart = (e) => Down(e.touches[0].clientX, e.touches[0].clientY);
    const onTouchMove = (e) => Move(e.touches[0].clientX, e.touches[0].clientY);

    const onLoadImage = () => {
        setIsVisible(true);

        let w = calculateWidth()[0];

        setWidth(w);
        widthRef.current = w;

        setHeight(startingHeight);
        heightRef.current = startingHeight;

        imageAspectRatioRef.current = calculateWidth()[1];

        setBaseSize({ w: calculateWidth()[0], h: startingHeight });
    }

    const pointerLastX = useRef();
    const pointerLastY = useRef();
    const isResizingRef = useRef(false);
    const initialWidthRef = useRef(calculateWidth()[0]);
    const initialHeightRef = useRef(startingHeight);
    const widthRef = useRef(initialWidthRef.current);
    const heightRef = useRef(initialHeightRef.current);

    // drag baseline (size at pointerDown)
    const dragBaseWRef = useRef(width);
    const dragBaseHRef = useRef(height);
    // virtual un-clamped deltas since pointerDown
    const dragDXRef = useRef(0);
    const dragDYRef = useRef(0);
    const currentScaleRef = useRef(1);

    var MAX_W = appWidth;
    var MAX_H = appHeight;
    var MIN_W = startingHeight;
    var MIN_H = startingHeight;

    const resizePointerDown = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (e.nativeEvent && e.nativeEvent.pointerId !== null) {
            e.currentTarget.setPointerCapture(e.nativeEvent.pointerId);
        }

        isResizingRef.current = true;
        pointerLastX.current = e.screenX;
        pointerLastY.current = e.screenY;

        // lock the baseline to the displayed size at drag start
        dragBaseWRef.current = width;
        dragBaseHRef.current = height;

        // reset virtual deltas
        dragDXRef.current = 0;
        dragDYRef.current = 0;
    };

    const resizePointerMove = (e) => {
        if (!isResizingRef.current) return;

        e.preventDefault();
        e.stopPropagation();

        const dx = (e.screenX - pointerLastX.current) / oxDivider;
        const dy = (e.screenY - pointerLastY.current) / oyDivider;

        // accumulate *virtual* deltas since drag start
        dragDXRef.current += dx * 2;
        dragDYRef.current += dy * 2;

        const aspectRatio = imageAspectRatioRef.current;

        // candidates based on drag
        const widthFromDX = dragBaseWRef.current + dragDXRef.current;
        const heightFromDY = dragBaseHRef.current + dragDYRef.current;

        // decide which axis is "dominant" for this drag
        let targetWidth;
        if (Math.abs(widthFromDX - dragBaseWRef.current) >= Math.abs(heightFromDY - dragBaseHRef.current)) {
            // dragging more horizontally → drive width directly
            targetWidth = widthFromDX;
        } else {
            // dragging more vertically → derive width from height, preserving ratio
            targetWidth = heightFromDY / aspectRatio;
        }

        // proposed size with locked aspect ratio
        let proposedW = targetWidth;
        let proposedH = proposedW * aspectRatio;

        // clamp by width first
        if (proposedW < MIN_W) {
            proposedW = MIN_W;
            proposedH = proposedW * aspectRatio;
        }
        if (proposedW > MAX_W) {
            proposedW = MAX_W;
            proposedH = proposedW * aspectRatio;
        }

        // then clamp by height (and adjust width to keep ratio)
        if (proposedH < MIN_H) {
            proposedH = MIN_H;
            proposedW = proposedH / aspectRatio;
        }
        if (proposedH > MAX_H) {
            proposedH = MAX_H;
            proposedW = proposedH / aspectRatio;
        }

        currentScaleRef.current = proposedH / startingHeight;

        if (scalingResizeRef.current * currentScaleRef.current < 1) {
            setUseSmallDrawMenu(true)
        } else {
            setUseSmallDrawMenu(false)
        }

        // final clamped size with correct ratio
        widthRef.current = proposedW;
        heightRef.current = proposedH;
        setWidth(proposedW);
        setHeight(proposedH);

        if (shared) {
            if (!mustBeDeletedRef.current) {
                ShareDocument(false, true);
                isResizeNecessary.current = false;
            }
        }

        pointerLastX.current = e.screenX;
        pointerLastY.current = e.screenY;
    };

    const windowPointerUp = () => {
        isResizingRef.current = false;

        if (shared) {
            if (!mustBeDeletedRef.current) {
                ShareDocument(false, true);
            }
        } else {
            SaveOpenedFilesState();
        }
    };


    return (
        <>
            <CustomMultitouchComponent ref={mtRef} dragGesture={false} x={appWidth / 2} y={appHeight / 2} onMinScaleReached={onMinScaleReached} onPinch={onPinch} onGestureEnded={onGestureEnded}
                options={options} onPointerDown={onDragStart} dragGestureMouse={true} dragBox={{ x: 0, y: 0, width: appWidth, height: appHeight }} isOpenCanvasRef={isOpenCanvasRef} >
                <div className={GetStyle(file)} ref={ref} style={containerStyle} onClick={() => touchClicked_handler()} >
                    {/* <div className={styles.shadowOverlay}/> */}
                    <img alt="imagine" ref={imgRef} style={{ borderRadius: "0px", width: "100%" }} onLoad={onLoadImage} draggable="false"
                        src={process.env.REACT_APP_CMS_URL + file.path} />
                    <div ref={canvasRef}
                        className={styles.canvasBoard}

                        onMouseDown={(e) => onMouseDown(e)}
                        onMouseMove={(e) => onMouseMove(e)}
                        onMouseUp={Up}
                        onMouseLeave={Up}

                        onTouchStart={(e) => onTouchStart(e)}
                        onTouchMove={(e) => onTouchMove(e)}
                        onTouchEnd={Up}

                        style={openCanvas ? {} : { touchAction: "none", userSelect: "none", pointerEvents: "none" }}
                    >
                        <svg width="100%" height="100%" viewBox={`0 0 ${baseSize.w} ${baseSize.h}`}>
                            {lines?.map((line, index) => (
                                <polyline
                                    key={index}
                                    points={line.points.map(([x, y]) => `${x},${y}`).join(' ')}
                                    fill="none"
                                    stroke={line.color}
                                    strokeWidth={line.strokeWidth}
                                />
                            ))}
                            <polyline
                                points={currentLine.map(([x, y]) => `${x},${y}`).join(' ')}
                                fill="none"
                                stroke={currentColor}
                                strokeWidth={currentStrokeWidth}
                            />
                        </svg>
                    </div>
                    {!isTouchDevice() && <div className={styles.drawButton} style={getButtonStyle(10)} onClick={onMinScaleReached} >
                        <FontAwesomeIcon icon={byPrefixAndName.fas["xmark"]} />
                    </div>}

                    {!shared && ((currentConference.type === "Presentation" && currentConference.moderatedBy === currentParticipant?._id) ||
                        currentConference.type === "Meeting" || currentParticipant?._id === currentTopic?.moderator._id || file.isModerator) &&
                        <img src={ShareIcon} style={getButtonStyle(isTouchDevice() ? 10 : 80)} alt="ShareIcon" draggable={false} oncl
                            onClick={(e) => {
                                if (opacity === 1) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    ShareDocument(false, true);
                                }
                            }} />
                    }
                    {shared && file.sharedBy === currentParticipant?._id && file.moderatedBy === currentParticipant?._id && currentConference.type !== "Meeting" &&
                        <img src={HandoverIcon} style={getButtonStyle(isTouchDevice() ? 10 : 80)} alt="HandoverIcon" draggable={false}
                            onClick={(e) => {
                                if (opacity === 1) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setShowParticipantsToShare(true);
                                    setOpacity(0)
                                }
                            }} />
                    }
                    {shared && file.sharedBy === currentParticipant?._id && file.moderatedBy !== currentParticipant?._id && currentConference.type !== "Meeting" &&
                        <img src={HandoverOffIcon} style={getButtonStyle(isTouchDevice() ? 10 : 80)} alt="HandoverOffIcon" draggable={false}
                            onClick={(e) => {
                                if (opacity === 1) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    ChangeModerator(currentParticipant);
                                    setOpacity(0)
                                }
                            }} />
                    }
                    {shared && file.moderatedBy === currentParticipant?._id &&
                        <div className={styles.drawButton} draggable={false} style={getButtonStyle(
                            (file.sharedBy !== currentParticipant?._id && file.moderatedBy === currentParticipant?._id) || currentConference.type === "Meeting" ?
                                (isTouchDevice() ? 10 : 80) : buttonsWidth + (isTouchDevice() ? 70 : 140),
                            10,
                            buttonsWidth
                        )}
                            onClick={(e) => {
                                if (opacity === 1) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setOpenCanvas(true)
                                    setOpacity(0)
                                }
                            }}
                        >
                            <FontAwesomeIcon icon={byPrefixAndName.fas["pen-swirl"]} />
                        </div>
                    }
                    {openCanvas && file.moderatedBy === currentParticipant?._id && !useSmallDrawMenu && <div className={styles.drawMenu}
                        style={{ transform: `scale(${1 / scalingButtonsRef.current}) translateY(-50%)` }}>
                        <FontAwesomeIcon className={styles.iconDrawMenu} style={{ color: "#6A658B" }} icon={byPrefixAndName.fal["close"]} onClick={() => {
                            setOpenCanvas(false)
                            setOpacity(1)
                        }} />
                        <FontAwesomeIcon className={styles.iconDrawMenu} icon={byPrefixAndName.fal["trash"]} onClick={() => {
                            linesRef.current = [];
                            setLines([]);
                            ShareDocument(false, true);
                        }} />
                        <FontAwesomeIcon className={styles.iconDrawMenu} icon={byPrefixAndName.fal["arrow-rotate-left"]} onClick={() => {
                            linesRef.current = linesRef.current.slice(0, -1);
                            setLines(linesRef.current);
                            ShareDocument(false, true);
                        }} />
                        <div className={styles.drawMenuColors} >
                            {["red", "orange", "yellow", "green", "blue", "purple", "white", "black"].map((color) => (
                                <div
                                    key={color}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setCurrentColor(color);
                                    }}
                                    className={styles.drawMenuColorCircle}
                                    style={{
                                        backgroundColor: color,
                                        border: currentColor === color ? "4px solid #FFFFFF99" : "4px solid transparent",
                                    }}
                                />
                            ))}
                        </div>
                        <FontAwesomeIcon className={styles.iconDrawMenu} icon={byPrefixAndName.fas["scribble"]}
                            onClick={() => setCurrentStrokeWidth(7)} />
                        <FontAwesomeIcon className={styles.iconDrawMenu} icon={byPrefixAndName.far["scribble"]}
                            onClick={() => setCurrentStrokeWidth(5)} />
                        <FontAwesomeIcon className={styles.iconDrawMenu} icon={byPrefixAndName.fal["scribble"]}
                            onClick={() => setCurrentStrokeWidth(3)} />
                        <FontAwesomeIcon className={styles.iconDrawMenu} icon={byPrefixAndName.fat["scribble"]}
                            onClick={() => setCurrentStrokeWidth(1)} />
                    </div>}
                    {openCanvas && file.moderatedBy === currentParticipant?._id && useSmallDrawMenu &&
                        <div className={styles.drawMenuSmall} style={{ transform: `scale(${1 / scalingButtonsRef.current}) translateY(-50%)` }}>
                            <div className={styles.drawMenuSmallHalf} >
                                <FontAwesomeIcon className={styles.iconDrawMenu} style={{ color: "#6A658B" }} icon={byPrefixAndName.fal["close"]} onClick={() => {
                                    setOpenCanvas(false)
                                    setOpacity(1)
                                }} />
                                <FontAwesomeIcon className={styles.iconDrawMenu} icon={byPrefixAndName.fal["trash"]} onClick={() => {
                                    linesRef.current = [];
                                    setLines([]);
                                    ShareDocument(false, true);
                                }} />
                                <FontAwesomeIcon className={styles.iconDrawMenu} icon={byPrefixAndName.fal["arrow-rotate-left"]} onClick={() => {
                                    linesRef.current = linesRef.current.slice(0, -1);
                                    setLines(linesRef.current);
                                    ShareDocument(false, true);
                                }} />

                                <div className={styles.drawMenuSeparator} />

                                <FontAwesomeIcon className={styles.iconDrawMenu} icon={byPrefixAndName.fas["scribble"]}
                                    onClick={() => setCurrentStrokeWidth(7)} />
                                <FontAwesomeIcon className={styles.iconDrawMenu} icon={byPrefixAndName.far["scribble"]}
                                    onClick={() => setCurrentStrokeWidth(5)} />
                                <FontAwesomeIcon className={styles.iconDrawMenu} icon={byPrefixAndName.fal["scribble"]}
                                    onClick={() => setCurrentStrokeWidth(3)} />
                                <FontAwesomeIcon className={styles.iconDrawMenu} icon={byPrefixAndName.fat["scribble"]}
                                    onClick={() => setCurrentStrokeWidth(1)} />
                            </div>
                            <div className={styles.drawMenuSmallHalf}
                                style={{ border: "none" }}>
                                <div className={styles.drawMenuColors}
                                    style={{ gap: "0px", height: "100%", justifyContent: "space-evenly", border: "none", padding: "18px 0px" }}>
                                    {["red", "orange", "yellow", "green", "blue", "purple", "white", "black"].map((color) => (
                                        <div
                                            key={color}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setCurrentColor(color);
                                            }}
                                            className={styles.drawMenuColorCircle}
                                            style={{
                                                backgroundColor: color,
                                                border: currentColor === color ? "4px solid #FFFFFF99" : "4px solid transparent",
                                            }}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    }
                    {!isTouchDevice() && <div ref={resizeButtonRef} className={styles.resizeButton} onPointerDown={resizePointerDown}
                        style={{ opacity: opacity, pointerEvents: opacity ? 'auto' : 'none' }}>
                        <img src={resizeButton} alt={"resizeButton"} draggable={false} />
                    </div>}
                </div>
            </CustomMultitouchComponent>
            {showParticipantsToShare &&
                <ParticipantsToShareComponent setShowParticipantsToShare={setShowParticipantsToShare} ChangeModerator={ChangeModerator}></ParticipantsToShareComponent>

            }
        </>
    );

}

export default ImageFileComponent;